// BE vbdt — VBDT/Controllers/MenuController.cs
export const apiGetListTab = '/api/roles/tabs'
export const apiGetMenu = '/api/menus/user-menu'
